import { Redirect } from "expo-router";

/** A bare `/shows` has no param-less public page; send it to the vendor's Shows index. */
export default function ShowsIndexScreen() {
  return <Redirect href="/manage/shows" />;
}
